import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld';
import Index from '@/components/Index';
import cj from '@/components/cj'
import Memberinfo from '@/components/Memberinfo'
import Usercont from '@/components/Usercont'
import Message from '@/components/Message'
import Team from '@/components/Team'
import News from '@/components/News'
import Newscont from '@/components/Newscont'
import Member from '@/components/Member'
import Memberkt from '@/components/Memberkt'
import About from '@/components/About'
import Smrz from '@/components/Smrz'
import Keyword from '@/components/Keyword'
import Wechat from '@/components/Wechat'
import Ewm from '@/components/Ewm'
import MemberList from '@/components/MemberList'
Vue.use(Router)

const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}


export default new Router({
	mode: 'history',  //去掉url中的#
  routes: [
    {
      path: '/',
      component: Index,
      meta: {
        title: '首页',
        type:'login',
        keepAlive:true,
      },
    },
    {
      path: '/Wechat',
      component: Wechat,
      meta: {
        title: '微信登录',
      }
    },

    {
      path: '/Memberinfo',
      component: Memberinfo,
      meta: {
        title: '完善信息',
        // type:'login'
      }
    },
	{
	  path: '/Ewm',
	  component: Ewm,
	  meta: {
	    title: '我的推广码',
	    // type:'login'
	  }
	},
    {
      path: '/Usercont',
      component: Usercont,
      meta: {
        title: '信息详情',
        type:'login'
      }
    },
    {
      path: '/Message',
      component: Message,
      meta: {
        title: '消息',
        keepAlive:true,
        type:'login'
      }
    },
	{
	  path: '/Team',
	  component: Team,
	  meta: {
	    title: '团队',
	    keepAlive:true,
	    type:'login'
	  }
	},
	
    {
      path: '/News',
      component: News,
      meta: {
        title: '新闻',
         keepAlive:true,
        type:'login'
      }
    },
    {
      path: '/Newscont',
      component: Newscont,
      meta: {
        title: '新闻详情',
        type:'login'
      }
    },
    {
      path: '/Member',
      component: Member,
      meta: {
        title: '我的',
        type:'login'
      }
    },
    {
      path: '/Memberkt',
      component: Memberkt,
      meta: {
        title: '开通会员',
        type:'login'
      }
    },
    {
      path: '/About',
      component: About,
      meta: {
        title: '内容',
        type:'login'
      }
    },
    {
      path: '/Smrz',
      component: Smrz,
      meta: {
        title: '实名认证',
        type:'login'
      }
    },
    {
      path: '/Keyword',
      component: Keyword,
      meta: {
        title: '搜索',
        keepAlive:true,
        type:'login'
      }
    },
    {
      path: '/MemberList',
      component: MemberList,
      meta: {
        title: '会员列表',
        type:'login'
      }
    },




  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js